import * as types from './types';

export const bookingReportsMutations = {
  [types.SET_BOOKING_REPORTS_ARTIST_REPORT](state, payload) {
    state.bookingReportsArtistReport = payload;
  }
}